export default "__VITE_ASSET__Dd3mYKhl__"